import './styles.scss';

interface ICheckboxProps {
  setChecked(): void;
  checked: boolean;
}

const Checkbox = ({ setChecked, checked }: ICheckboxProps) => {
  return (
    <div className='checkbox'>
      <input
        type='checkbox'
        className='checkbox__input'
        checked={checked}
        onChange={setChecked}
      />
    </div>
  );
};

export default Checkbox;
